var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subscription-footer" }, [
    _c(
      "div",
      {
        staticClass: "main-container",
        class: { "flex-between-wrapper": _vm.withOption },
      },
      [
        _vm.withOption
          ? _c("img", {
              staticClass: "footer-picture",
              attrs: { src: "/assets/app/class/reading-compre-bg.png" },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "main-content",
            class: { "with-option": _vm.withOption },
          },
          [
            _c(
              "a",
              { attrs: { href: "/" } },
              [
                _c("rt-picture", {
                  staticClass: "footer-img",
                  attrs: { src: "/assets/app/class/icon-logo-white.svg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "title-improve" }, [
              _vm._v("Improve your students’"),
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "title-reading" }, [
              _vm._v("Reading Comprehension."),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "footer-description" }, [
              _vm._v(
                "Personalized reading comprehension exercises for K-12 and ESL students."
              ),
            ]),
            _vm._v(" "),
            _c(
              "primary-button",
              {
                staticClass: "btn-choose-plan",
                on: { click: _vm.handleClickChoose },
              },
              [_vm._v("Choose Your Plan")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }